// extracted by mini-css-extract-plugin
module.exports = {"page-footer":"Footer__page-footer__1Mcj2","contactDetails":"Footer__contactDetails__1O5m8","tooltip":"Footer__tooltip__3Q_Vv","tooltipText":"Footer__tooltipText__1TIij"};